

class ReportColumnVisibilityViewController extends MUIViewController
{    
    static newInstance() : ReportColumnVisibilityViewController {
        let vc = new ReportColumnVisibilityViewController("report-column-visiblity-view");
        vc.initWithResource("layout/reports/ReportColumnVisibilityView.html");
        return vc;
    }    

    get preferredContentSize(): MIOSize {
        return new MIOSize(320, 500);
    }

    delegate:any = null;

    private applyButton:MUIButton = null;
    private backButton:MUIButton = null;
    private tableView:UITableView = null;
    viewDidLoad() {
        this.applyButton = MUIOutlet(this, "apply-btn", "MUIButton");
        this.applyButton.setAction(this, this.applyAction);

        // only shown when pushed (dashboard widget options); as a plain
        // popover the view dismisses by tapping outside, as always
        this.backButton = MUIOutlet(this, "back-btn", "MUIButton");
        this.backButton?.setAction(this, function(this:ReportColumnVisibilityViewController){
            this.navigationController?.popViewController(true);
        });

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this;
        this.tableView.setEditing(true);
    }

    viewWillAppear(animated?: any): void {
        super.viewWillAppear(animated);
        if (this.backButton != null) {
            if (this.navigationController != null) MUICoreLayerRemoveStyle(this.backButton.layer, "hidden");
            else MUICoreLayerAddStyle(this.backButton.layer, "hidden");
        }
        this.updateUI();
    }

    private reportID:string = null;
    private options:ReportOption[] = [];
    private userOtionsMap = {};
    setColumnOptions(reportID:string, options:ReportOption[]) {
        this.reportID = reportID;
        this.options = options;
        this.updateUI();
    }

    private updateUI(){
        if (this.viewIsLoaded == false) return;
        this.tableView.reloadData();
    }

    numberOfSections(tableView:UITableView){
        return this.options.count;
    }
    
    numberOfRowsInSection(tableView:UITableView, section:number){
        return this.options[section].columns.length;
    }

    titleForHeaderInSection?(tableView:UITableView, section){
        return MIOLocalizeString(this.options[section].key, this.options[section].key);
    }

    cellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath) {
        let cell = tableView.dequeueReusableCellWithIdentifier("ColumnCell") as ReportColumnVisibilityCell;
        cell.item = this.options[indexPath.section].columns[indexPath.row];
        return cell;
    }

    didSelectCellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){
        let cell = tableView.cellAtIndexPath(indexPath) as UITableViewCell;
        let opt = this.options[indexPath.section];
        let col = opt.columns[indexPath.row];
        col.hidden = !col.hidden;
        cell.accessoryType = col.hidden ? UITableViewCellAccessoryType.None : UITableViewCellAccessoryType.Checkmark;
        this.ensureUserOption(opt, col);
        col.userOption.hidden = col.hidden;
    }

    private ensureUserOption(opt:ReportOption, col:ReportColumnOption){
        if (col.userOption != null) return;
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        col.userOption = MIOEntityDescription.insertNewObjectForEntityForName("UserReportOption", ad.managedObjectContext) as UserReportOption;
        col.userOption.reportID = this.reportID;
        col.userOption.reportItemKey = opt.key;
        col.userOption.reportColumnKey = col.key;
        col.userOption.user = ad.selectedUser;
        col.userOption.hidden = col.hidden;
    }

    // MARK: - Drag & drop column reordering

    canMoveRowAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath):boolean {
        return true;
    }

    // Columns only reorder inside their own table (= section)
    targetIndexPathForMoveFromRowAtIndexPath(tableView:UITableView, from:MIOIndexPath, proposed:MIOIndexPath):MIOIndexPath {
        if (proposed.section == from.section) return proposed;
        let lastRow = this.options[from.section].columns.length - 1; // dragged row excluded
        return MIOIndexPath.indexForRowInSection(proposed.section < from.section ? 0 : lastRow, from.section);
    }

    moveRowAtIndexPath(tableView:UITableView, from:MIOIndexPath, to:MIOIndexPath){
        let opt = this.options[from.section];
        let col = opt.columns[from.row];
        opt.columns.splice(from.row, 1);
        opt.columns.splice(to.row, 0, col);

        // Materialize the order on every column of this item so it is total
        for (let i = 0; i < opt.columns.length; i++){
            this.ensureUserOption(opt, opt.columns[i]);
            opt.columns[i].userOption.orderIndex = i;
        }
        this.updateUI();
    }

    private applyAction(){
        DBHelper.saveMainContext();
        if (this.delegate != null) this.delegate.applyVisibilityOptions(this.options);
        if (this.navigationController != null) this.navigationController.popViewController(true);
        else this.dismissViewController(true);
    }
}